import React, { useState, useEffect, useMemo } from 'react';
import { Container, Card, Button, Form, InputGroup, Row, Col, Modal } from 'react-bootstrap';
import { FaBus, FaArrowRight, FaRupeeSign, FaUser, FaPhoneAlt, FaEnvelope, FaCalendarCheck, FaStickyNote, FaUsers, FaChevronDown } from 'react-icons/fa';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import axios from 'axios';
import BASE_URL from '../../component/commanfile';

const TourBookingCard = ({ packages }) => {
  const [selectedType, setSelectedType] = useState(packages?.type === "fit" ? 'fit' : 'schedule');
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedDateId, setSelectedDateId] = useState(null);
  const [selectedVehicleIdx, setSelectedVehicleIdx] = useState(0);
  const [selectedFitRateId, setSelectedFitRateId] = useState(null);
  const [occupancy, setOccupancy] = useState('doubleOccupancy');
  console.log("selectedDate:", packages);
  const [formErrors, setFormErrors] = useState({}); // NEW state for errors
const [showSuccess, setShowSuccess] = useState(false); // Modal state
const theme = {
    primary: "#0a3b78",
    dark: "#1c0a0a"
  };
  const [formData, setFormData] = useState({
    name: '', mobile: '', email: '', customerNotes: '', adults: 0, children: 0
  });

  const validSchedules = useMemo(() => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return packages?.tourSchedule?.filter(batch => {
      const d = new Date(batch.startDate);
      return d >= today;
    }) || [];
  }, [packages]);

  const enabledDates = useMemo(() => validSchedules.map(s => new Date(s.startDate)), [validSchedules]);
  const activeBatch = validSchedules.find(b => b.id === selectedDateId) || {};

  // AUTO-SELECT FIRST RATE WHEN VEHICLE CHANGES
  useEffect(() => {
    if (selectedType === 'fit' && packages?.forfit?.[selectedVehicleIdx]) {
      const firstRate = packages.forfit[selectedVehicleIdx].seatConfigurationRate?.[0];
      if (firstRate) setSelectedFitRateId(firstRate.id);
    }
  }, [selectedType, selectedVehicleIdx, packages]);

  // NEW LOGIC: When Pax is selected, update Adult count automatically
  useEffect(() => {
    if (selectedType === 'fit' && selectedFitRateId) {
      const currentVehicle = packages?.forfit?.[selectedVehicleIdx];
      const activeRate = currentVehicle?.seatConfigurationRate?.find(r => r.id === selectedFitRateId);

      if (activeRate) {
        setFormData(prev => ({
          ...prev,
          adults: parseInt(activeRate.numberOfPerson) || 1,
          children: 0 // Reset children to 0 when a new pax bracket is chosen
        }));
      }
    }
  }, [selectedFitRateId, selectedType, selectedVehicleIdx, packages]);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    const match = validSchedules.find(s => new Date(s.startDate).toDateString() === date.toDateString());
    if (match) setSelectedDateId(match.id);
  };

  const calculateTotal = () => {
    if (selectedType === 'fit') {
      const currentFitVehicle = packages?.forfit?.[selectedVehicleIdx];
      const activeRate = currentFitVehicle?.seatConfigurationRate?.find(r => r.id === selectedFitRateId);
      return parseFloat(activeRate?.price || 0) * (formData.adults + formData.children);
    }
    return parseFloat(activeBatch[occupancy] || 0) * (formData.adults + formData.children);
  };

  const styles = {
    card: { border: 'none', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)', background: '#fff' },
    header: { background: '#0a3b78', color: '#fff', padding: '15px', textAlign: 'center', fontWeight: 'bold' },
    vehicleTile: (active) => ({
      cursor: 'pointer', padding: '12px', borderRadius: '12px',
      border: active ? '2px solid #0a3b78' : '1px solid #dee2e6',
      backgroundColor: active ? '#f0f7ff' : '#fff',
      textAlign: 'center', minWidth: '140px', transition: '0.3s'
    }),
    paxBadge: (active) => ({
      cursor: 'pointer', padding: '8px 15px', borderRadius: '20px', fontSize: '12px', fontWeight: '600',
      border: active ? '1px solid #0a3b78' : '1px solid #dee2e6',
      backgroundColor: active ? '#0a3b78' : '#fff',
      color: active ? '#fff' : '#666', transition: '0.2s'
    }),
    dateBox: { background: '#eef6ff', border: '1px solid #0a3b78', borderRadius: '8px', padding: '12px', color: '#0a3b78', fontWeight: '600', marginTop: '15px', textAlign: 'center' }
  };

  const validateForm = () => {
    const errors = {};

    // Name check
    if (!formData.name.trim()) errors.name = "Name is required";

    // Mobile check
    if (!formData.mobile.trim()) {
      errors.mobile = "Mobile number is required";
    }

    // // Email check
    // if (!formData.email.trim()) {
    //   errors.email = "Email is required";
    // } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
    //   errors.email = "Enter a valid email address";
    // }



    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleBookingSubmit = async () => {
    if (!validateForm()) return; // Stop submission if invalid

    const isFit = selectedType === 'fit';
    const activeVehicle = isFit ? packages?.forfit[selectedVehicleIdx] : null;
    const activeFitRate = activeVehicle?.seatConfigurationRate?.find(r => r.id === selectedFitRateId);



    const payload = {
      name: formData.name,
      mobileNumber: formData.mobile,
      email: formData.email,
      type: packages?.type == "fit" ? "fit" : "package",
      selectedPackage: packages?.type == "fit" ? "" : packages?.id || "",
      fitPackage: packages?.type === "fit" ? packages?.id || "" : "",
      selectedSchedule: packages?.type != "fit" ? selectedDateId || "" : "",
      customerNotes: formData.customerNotes,
      adults: formData.adults || 1,
      children: formData.children || 0,
      tentativeDate: isFit
        ? (selectedDate ? selectedDate.toISOString() : "")
        : (activeBatch?.startDate || ""),
      hotelCategory: isFit ? "" : occupancy,
      vehicle: isFit ? activeVehicle?.id : "",
      selectedFitRateId: selectedFitRateId || "",
      fitPackage: packages?.type === "fit" ? packages?.id || "" : "",
      vehicle: isFit ? activeVehicle?.id : "",
      tourFitFlag: packages?.type == "fit" ? "true" : isFit ? "true" : "false",
      selectedPrivateVehicleRateId: selectedFitRateId || "",
    };

    console.log("activeFitRate", formData, activeFitRate)
    try {
      const res = await axios.post(`${BASE_URL}api/tourinquery`, payload);
   setShowSuccess(true); // Trigger Success Modal
      setFormData({ name: '', mobile: '', email: '', customerNotes: '', adults: 1, children: 0 });
      setSelectedDate(null);
      setFormErrors({});
    } catch (err) {
      console.error("Booking Error:", err);
      alert('Failed to send booking request. Please try again.');
    }
  };
  return (
    <Container className='p-0'>
      <style>{`
    .react-datepicker { border: none !important; width: 100%; display: flex; justify-content: center; }
    .compact-input { padding: 0.4rem 0.6rem !important; font-size: 0.85rem !important; height: auto !important; }
    .section-label { font-size: 0.7rem; font-weight: 700; color: #6c757d; text-transform: uppercase; margin-bottom: 4px; display: block; }
    .vehicle-tile { min-width: 85px; cursor: pointer; border: 1px solid #eee; transition: 0.2s; text-align: center; padding: 6px; border-radius: 8px; }
    .error-msg { font-size: 0.65rem; color: #dc3545; margin-top: 2px; }
  `}</style>

      <Card className="border-0 shadow-sm" style={{ borderRadius: '12px', overflow: 'hidden' }}>
        <div className="text-white text-center fw-bold py-2" style={{ backgroundColor: '#0a3b78', fontSize: '0.85rem', letterSpacing: '1px' }}>
          TOUR INQUIRY & BOOKING
        </div>

        <Card.Body className="p-3" style={{ maxHeight: '82vh', overflowY: 'auto' }}>

          {/* 1. VEHICLE & PAX */}
          <div className="mb-2">
            <span className="section-label">1. Vehicle & Occupancy</span>
            <div className="d-flex gap-2 overflow-auto pb-1 mb-2">
              {packages.type !== "fit" && (
                <div className="vehicle-tile flex-shrink-0" style={{ borderColor: selectedType === 'schedule' ? '#0a3b78' : '#eee', backgroundColor: selectedType === 'schedule' ? '#f0f4f8' : '#fff' }} onClick={() => setSelectedType('schedule')}>
                  <FaBus size={14} color={selectedType === 'schedule' ? '#0a3b78' : '#ccc'} />
                  <div className="fw-bold mt-1" style={{ fontSize: '0.65rem' }}>Group Bus</div>
                </div>
              )}
              {packages?.forfit?.map((veh, index) => (
                <div key={index} className="vehicle-tile flex-shrink-0" style={{ borderColor: (selectedType === 'fit' && selectedVehicleIdx === index) ? '#0a3b78' : '#eee', backgroundColor: (selectedType === 'fit' && selectedVehicleIdx === index) ? '#f0f4f8' : '#fff' }} onClick={() => { setSelectedType('fit'); setSelectedVehicleIdx(index); }}>
                  <FaBus size={14} color={selectedType === 'fit' && selectedVehicleIdx === index ? '#0a3b78' : '#ccc'} />
                  <div className="fw-bold mt-1 text-truncate" style={{ fontSize: '0.65rem' }}>{veh.vehicleName || veh.vihicalname || 'Private'}</div>
                </div>
              ))}
            </div>

            {selectedType === 'fit' ? (
              <div className="p-2 border rounded-3 bg-light">
                <label className="section-label"><FaUsers className="me-1" /> Select Number of Persons</label>
                <div className="d-flex gap-2 flex-wrap">
                  {packages.forfit[selectedVehicleIdx].seatConfigurationRate.map((rate) => (
                    <div
                      key={rate.id}
                      style={styles.paxBadge(selectedFitRateId === rate.id)}
                      onClick={() => setSelectedFitRateId(rate.id)}
                      className="px-2 py-1 rounded-3"
                    >
                      {rate.numberOfPerson} Pax {`(₹ ${rate.price})`}
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <Form.Select size="sm" className="compact-input" value={occupancy} onChange={e => setOccupancy(e.target.value)}>
                <option value="doubleOccupancy">Double Occupancy</option>
                <option value="tripleOccupancy">Triple Occupancy</option>
              </Form.Select>
            )}
          </div>

          {/* 2. CALENDAR */}
          <div className="mb-2">
            <span className="section-label">2. Departure Date</span>
            <DatePicker
              selected={selectedDate}
              onChange={(date) => {     handleDateChange(date);  setFormErrors({ ...formErrors, date: null }); }}
              includeDates={packages?.type === "fit" ? undefined : enabledDates}
              customInput={
                <div className={`form-control d-flex align-items-center py-1 px-2 ${formErrors.date ? 'border-danger' : ''}`} style={{ cursor: 'pointer', borderRadius: '8px' }}>
                  <FaCalendarCheck className="text-primary me-2" size={14} />
                  <span style={{ fontSize: '0.85rem' }}>{selectedDate ? selectedDate.toLocaleDateString('en-GB') : "Select Date"}</span>
                </div>
              }
            />
            {formErrors.date && <div className="error-msg">{formErrors.date}</div>}
          </div>

          {/* 3. TRAVELER INFO */}
          <div className="mb-2">
            <span className="section-label">3. Traveler Info</span>
            <Row className="g-1">
              <Col xs={12} className="mb-1">
                <Form.Control size="sm" className={`compact-input ${formErrors.name ? 'border-danger' : ''}`} placeholder="Traveler Name" value={formData.name} onChange={e => setFormData({ ...formData, name: e.target.value })} />
              </Col>
              <Col xs={6}>
                <Form.Control size="sm" className={`compact-input ${formErrors.email ? 'border-danger' : ''}`} placeholder="Email" value={formData.email} onChange={e => setFormData({ ...formData, email: e.target.value })} />
                {formErrors.email && <div className="error-msg">{formErrors.email}</div>}
              </Col>
              <Col xs={6}>
                <Form.Control size="sm" className={`compact-input ${formErrors.mobile ? 'border-danger' : ''}`} placeholder="Mobile" value={formData.mobile} onChange={e => setFormData({ ...formData, mobile: e.target.value })} />
                {formErrors.mobile && <div className="error-msg">{formErrors.mobile}</div>}
              </Col>

              <Col xs={6}>
                <div className="d-flex align-items-center justify-content-between border rounded px-2 py-1">
                  <span style={{ fontSize: '0.7rem' }}>Adults</span>
                  <div className="d-flex align-items-center gap-2">
                    <button className="btn btn-link p-0 text-dark text-decoration-none fw-bold" onClick={() => setFormData({ ...formData, adults: Math.max(1, formData.adults - 1) })}>-</button>
                    <span className="small fw-bold">{formData.adults}</span>
                    <button className="btn btn-link p-0 text-dark text-decoration-none fw-bold" onClick={() => setFormData({ ...formData, adults: formData.adults + 1 })}>+</button>
                  </div>
                </div>
              </Col>
              <Col xs={6}>
                <div className="d-flex align-items-center justify-content-between border rounded px-2 py-1">
                  <span style={{ fontSize: '0.7rem' }}>Kids</span>
                  <div className="d-flex align-items-center gap-2">
                    <button className="btn btn-link p-0 text-dark text-decoration-none fw-bold" onClick={() => setFormData({ ...formData, children: Math.max(0, formData.children - 1) })}>-</button>
                    <span className="small fw-bold">{formData.children}</span>
                    <button className="btn btn-link p-0 text-dark text-decoration-none fw-bold" onClick={() => setFormData({ ...formData, children: formData.children + 1 })}>+</button>
                  </div>
                </div>
              </Col>
              <Col xs={12} className="mb-1">
                <Form.Control as="textarea" type='textarea' className={`compact-input ${formErrors.customerNotes ? 'border-danger' : ''}`} placeholder="Customer Notes" value={formData.customerNotes} onChange={e => setFormData({ ...formData, customerNotes: e.target.value })} />
              </Col>
            </Row>
          </div>

          {/* FOOTER */}
          <div className="mt-3 pt-2 border-top">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <div style={{ fontSize: '0.6rem', color: '#999' }}>ESTIMATED TOTAL</div>
                <div className="h5 fw-bold text-primary mb-0">₹{calculateTotal().toLocaleString()}</div>
              </div>
              <Button className="px-3 py-2 fw-bold" style={{ backgroundColor: '#0a3b78', border: 'none', borderRadius: '6px', fontSize: '0.8rem' }} onClick={handleBookingSubmit}>
                Send Inquiry <FaArrowRight size={10} className="ms-1" />
              </Button>
            </div>
          </div>
        </Card.Body>
      </Card>

      <Modal show={showSuccess} onHide={() => setShowSuccess(false)} centered size="md">
        <Modal.Body className="p-0 overflow-hidden" style={{ borderRadius: '15px' }}>
          <div className="text-center py-5 px-4 animate__animated animate__fadeIn">
            <div className="mb-4">
              <div style={{ 
                width: "90px", height: "90px", background: "#f0fff4", color: "#28a745", 
                borderRadius: "50%", display: "inline-flex", alignItems: "center", 
                justifyContent: "center", fontSize: "2.5rem", boxShadow: "0 10px 20px rgba(40, 167, 69, 0.1)"
              }}>✓</div>
            </div>

            <h3 className="fw-bold" style={{ color: theme.dark, marginBottom: "15px" }}>
              Inquiry Submitted Successfully!
            </h3>
            
            <div className="px-md-2">
              <p style={{ color: "#555", lineHeight: "1.6", fontSize: "1rem" }}>
                Dear <strong>{formData.name || "Traveler"}</strong>, thank you for choosing 
                Radheshyam Group. We have received your inquiry for the <strong>{packages?.name}</strong>.
              </p>
              
              <p className="text-muted small" style={{ backgroundColor: "#f8f9fa", padding: "15px", borderRadius: "12px", borderLeft: `4px solid ${theme.primary}` }}>
                One of our senior destination experts will review your requirements. 
                You will receive a personalized itinerary and quote within the next 24 hours.
              </p>
            </div>

            <div className="mt-4 pt-3 border-top w-100">
              <p className="mb-1 fw-bold" style={{ color: theme.primary }}>Radheshyam Group</p>
              <span className="text-muted small">Quality Tours • Trusted Service • Best Price</span>
              <div className="mt-3">
                 <Button variant="outline-primary" size="sm" onClick={() => setShowSuccess(false)}>Close</Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default TourBookingCard;

